module.exports = __webpack_public_path__ + "img/Office.d5f8db09.jpg";